import React, { useState, useEffect } from "react";
import MapIcon from "../../../images/map.svg";
import "select2";
import $ from "jquery";

const Opticas = ({ data }) => {
	const [filtroZonas, setZonas] = useState("");
	const [opticasFiltradas, setOpticasFiltradas] = useState([]);
	const [showNoOpticas, setShowNoOpticas] = useState(false);

	const actualizarURL = () => {
		const queryParams = new URLSearchParams();

		if (filtroZonas) {
			queryParams.set("zona", filtroZonas);
		}
		const nuevaURL = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.replaceState({}, "", nuevaURL);
	};

	const leerParametrosURL = () => {
		const parametrosURL = new URLSearchParams(window.location.search);

		const zonaParam = parametrosURL.get("zona") || "";

		// Evita actualizaciones innecesarias de estado
		if (zonaParam !== filtroZonas) {
			setZonas(zonaParam);
			$("#zonitas").val(zonaParam).trigger("change");
		}
	};
	useEffect(() => {
		$('#zonitas').select2({
			placeholder: "Sedes de SportClub",
			width: "100%",
		}).on('change', (e) => setZonas(e.target.value))
		// eslint-disable-next-line
	}, []);
	useEffect(() => {
		leerParametrosURL();
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		actualizarURL();
		// eslint-disable-next-line
	}, [filtroZonas]);

	useEffect(() => {
		if (filtroZonas === "") {
			setOpticasFiltradas([]);
			setShowNoOpticas(false);
		} else if (filtroZonas === "todas") {
			setOpticasFiltradas(data);

		} else {
			const opticasFiltradas = data.filter((item) => {
				return (
					item.selectorDos.includes(filtroZonas)
				);
			});
			setOpticasFiltradas(opticasFiltradas);
			setShowNoOpticas(opticasFiltradas.length === 0)
		}
	}, [filtroZonas, data]);


	const mapita = (link) => {
		// alert("Por el poder del prisma Lunar");
		const mapaModal = document.getElementById("mapaz");
		mapaModal.src = link;
	}

	return (
		<div>
			<div className="container mt-3 p-0">
				<div className="row m-0">
					<div className="filter col-12 col-sm-6 col-lg-3 mt-3 mb-3 pe-lg-0">
						<select
							id="zonitas"
							defaultValue={filtroZonas}
						>
							<option value="">Sedes</option>
							<option value="parque">Sede Parque</option>
							<option value="Caballito">Sede Caballito</option>
							<option value="Constituyentes">Sede Constituyentes</option>
							<option value="dot">Sede DOT</option>
							<option value="hacoaj">Sede Hacoaj</option>
							<option value="plazaitalia">Sede Plaza Italia</option>
							<option value="laspalmas">Sede Las Palmas</option>
							<option value="tom">Sede TOM</option>
							<option value="diagonal">Sede Diagonal</option>
							<option value="belgranor">Sede Belgrano R</option>
							<option value="todas">Todas</option>
						</select>
					</div>
				</div>
			</div>
			<div className="container d-flex flex-wrap">
				{opticasFiltradas.map((item, index) => (
					<div key={index} className="col-12 col-md-6 col-lg-3 p-0">
						<a data-bs-toggle="modal" data-bs-target="#mapa" href="#mapa" target="_blank" rel="noreferrer" onClick={() => mapita(item.link)}>
							<div className="opticas-container row">
								<div className="col text-container p-0">

									<p>
										<span className="colorcito1">{item.optica}</span>{" "}
										{item.localidad}
									</p>
									<p className="adress">{item.direccion}</p>
								</div>
								<div className="col-2 map-icon text-end">
									<img src={MapIcon} alt="icono de mapa" />
								</div>
							</div>
						</a>
					</div>
				))}
				{showNoOpticas && <p className="colorcito2 mt-2 mb-2">No se encuentran ópticas disponibles en esta zona.</p>}
			</div>
			<div className="modal fade" id="mapa" tabIndex="-1" aria-labelledby="mapaLabel" aria-hidden="true">
				<div className="modal-dialog d-flex justify-content-center">
					<div className="modal-content map-content align-items-center">

						<h5 className="modal-title" id="voucherLabel">MAPA</h5>
						<iframe id="mapaz" width="600" height="450" src="" title="mapa" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
					</div>
				</div>
			</div>
		</div>
	);
};



export default Opticas;
